import React,{useState,useEffect} from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow
        ,Card, Box, Typography,
        Tooltip,
        IconButton} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    estiloCard:{
        width: '20rem',
        boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
       // color:'#4a4a4a',
        display:'block',
        padding:'1rem',
        maxHeight:'100%',
        //minHeight: 280,
        marginRight:'1rem'
    },
    formControl:{
        boxSizing:'border-box',
        fontSize:'1rem',
        position:'relative',
        marginBottom:'1em'
    },
    container: {
      width: '18rem',
      minHeight: window.innerHeight-190,
      //minWidth:'100%',
    },
    tablaContainer: {
        width: '18rem',
        maxHeight: window.innerHeight-240,
        minHeight: 280,
        //minWidth:'100%',
      },
    totalEstilo:{
        fontSize:'1.25rem',
        fontWeight:'bold'
    },
    tituloEstilo:{
        paddingBottom:'.25rem',
        fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });
  const columnas=[              
    { id:1, titulo:"Tipo", alinear:'center'   },     
    { id:2, titulo:"Observación", alinear:'center'   },     
  ];



const alturaCont = window.innerHeight<937 ? window.innerHeight-130 : window.innerHeight-150

export default function TablaPoligono({lista, setRutaSeleccion }){    
    const classes = useStyles();    
    const [promotor, setPromotor] = useState({nombre:""})
    const [seleccion, setSeleccion] = useState(null)
    const [datos,setDatos] = useState([]);     
    const [banderaVer, setBanderaVer] = useState(true);     
    const auxCol=process.env.REACT_APP_Fondo_Color
    const {nombre} = promotor;    
    useEffect(()=>{

        setDatos(lista)

        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[lista])          

    const onChangeTable =(regis)=>{                       
      setSeleccion(regis)
      setRutaSeleccion(regis)
    }

    function filtro(){        
      let auxCadena=nombre.trim();       
      let info=[];                        
      let aux=  datos.filter((dat)=>dat.nombreReg.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
      info=aux 
      let auxNum=0;
        if (aux!==null||aux!=='') 
        {
        aux.forEach((mun)=>
        { if (mun.nombreReg!=='PUEBLA')
          {   
            auxNum++;
          }                
        })
      }         
      return TablaEstr(info);
    }


    const celda = (alinear, estilo, contenido,index) => {
      return (
      <TableCell align={alinear} key={index} className={classes.tableCell} 
        padding={'none'} style={estilo} >
        {contenido}
      </TableCell>)
    }
    

  const CelTitl=({index,titulo,aline})=> celda(aline?aline:"center", {backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 

  function TablaEstr(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
      <Table stickyHeader aria-label="sticky table">
        <TableHead >    
          <TableRow>  

            <CelTitl index={5} titulo={auxDatos.length} />            
            {columnas.map((columna,index)=>              
              <CelTitl index={index+5} titulo={columna.titulo} aline={columna.alinear} />                          
            )}                                       
          </TableRow>                        
        </TableHead>  
        <TableBody>                                  
        {auxDatos.map((elemnto,index) => {  
          const auxVal=seleccion?.Id === elemnto.Id ?true:false     
          const fecha=moment.utc(elemnto.FEnv).local(true).format("DD/MM/YYYY HH:mm")                                         
          return (                  
          <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index} onClick={ () => onChangeTable(elemnto) }  
          >          
                                           
            {celda("center", {width:"3rem", paddingRight:".3rem", fontSize:"10px"}, fecha, index+6) }
            {  celda("left", {width:"5rem"}, <span><div>{`${elemnto.TipoNom} `}</div>
             </span>, index+8) } 
            {celda("left", {width:"3rem", paddingRight:".3rem", fontSize:"12px"}, `${elemnto.Obsrv}`, index+6) }                                             
          </TableRow>              
          );                        
          })
        }                                                
        </TableBody>
      </Table>
    </TableContainer>        
    ); 
  }                  
   
    //const contenido = nombre.length > 0 ? (filtro()):(TablaEstr(datos));    
    const llamada= datos.length !== 0 ?(TablaEstr(datos)):(<Box style={{paddingTop:1+'rem'}}><Typography variant="h4" component="h3">No contiene datos</Typography></Box>)
                              
                                
  return (
  <Box display={'flex'} flexDirection="column" style={{height: alturaCont}} ml={2}>
   
    <Card className={classes.estiloCard} style={{height:banderaVer ?window.innerHeight-160 : 60}}>
      <Box display={"flex"} flexDirection={"row"}>
        <Typography variant='h5' style={{marginRight:"8.5rem"}}>Recorridos</Typography>  
        <Tooltip title={banderaVer ? 'Ocultar Tabla' : "Mostrar Tabla"}>
        <IconButton color="primary" size="small"
          onClick={() => setBanderaVer(!banderaVer)}>
          {banderaVer?
            <img src='ic_minimize.svg' style={{width:"30px", height:"30px", marginBottom:".5rem"}}/>
            : <img src='ic_maximize.svg' style={{width:"30px", height:"30px"}}/>}
        </IconButton>
      </Tooltip>   
        
      </Box>                        
      
      {banderaVer ? llamada:null}   
    </Card>
       
  </Box>                    
  );
}